import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";
import { chartColors } from "@/components/charts/chartTheme";

export interface SparklinePoint {
  /** X-axis value — typically a date string, not rendered (no axes shown). */
  x: string;
  y: number;
}

interface SparklineChartProps {
  data: SparklinePoint[];
  /** Line/area color. Defaults to brand teal; pass chartColors.positive/negative for directional trends. */
  color?: string;
  height?: number;
}

/**
 * A minimal trend line with no visible axes or gridlines — designed to
 * sit inside a StatCard alongside a large numeral, communicating direction
 * and shape at a glance rather than precise values. Wrapped in
 * ResponsiveContainer so it never overflows its parent at any viewport
 * width, per the spec's mandatory responsive-chart requirement.
 */
export function SparklineChart({ data, color = chartColors.brand, height = 48 }: SparklineChartProps) {
  if (data.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 4, right: 2, bottom: 4, left: 2 }}>
        <YAxis hide domain={["dataMin", "dataMax"]} />
        <Line
          type="monotone"
          dataKey="y"
          stroke={color}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
